import { FC } from "react";
import { AirfieldCoordinates } from "../models/AirfieldCoordinates";
import AirfieldMapCard from "./airfield/AirfieldMapCard";
import { MapContainer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import MarkerClusterGroup from 'react-leaflet-cluster'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer'
import '../leafletCustomCss.css'


interface AirfiedlsMapProps {
	airfieldsCoordinates: AirfieldCoordinates[],
	isLoading: boolean,
}


const customIcon = new L.Icon({
	iconUrl: require('../images/location.svg').default,
	iconSize: new L.Point(40, 40),
})

const createClusterCustomIcon = function (cluster: any) {
	return L.divIcon({
		html: `<span>${cluster.getChildCount()}</span>`,
		className: 'custom-marker-cluster',
		iconSize: L.point(40, 40, true),
	})
}


const AirfieldsMap: FC<AirfiedlsMapProps> = (props) => {
	const { airfieldsCoordinates, isLoading } = props;

	return (
		<div>

			<>
				<MapContainer
					style={{
						height: "calc(100vh - 250px)", width: "100%"
					}}
					zoom={6}
					center={[
						40.95278265114086,
						12.49637028773154]}
					scrollWheelZoom={true}
				>
					<ReactLeafletGoogleLayer
						googleMapsLoaderConf={{ apiKey: "AIzaSyALsCrt7x4tjRdrEBioDLa67ggN5Eq9uZ0" }}
						type={'hybrid'}
						useGoogMapsLoader={true}
						continuousWorld={false} />
					<MarkerClusterGroup
						iconCreateFunction={createClusterCustomIcon}
						maxClusterRadius={50}
						spiderfyOnMaxZoom={true}
						polygonOptions={{
							fillColor: '#ffffff',
							color: '#2880CA',
							weight: 1,
							opacity: 0,
							fillOpacity: 0,
						}}
						showCoverageOnHover={false}
					>
						{Array.isArray(airfieldsCoordinates) && !isLoading &&
							airfieldsCoordinates.map((airfield: AirfieldCoordinates, index) =>
								<Marker key={airfield.id} position={[airfield.latitude, airfield.longitude]} icon={customIcon}>
									<Popup minWidth={90} >

										<AirfieldMapCard id={airfield.id || ""} />

									</Popup>
								</Marker>
							)}
					</MarkerClusterGroup>
				</MapContainer></>	</div>
	);
}

export default AirfieldsMap;
